import { render, staticRenderFns } from "./DatatableCell.vue?vue&type=template&id=a1441eae&"
import script from "./DatatableCell.vue?vue&type=script&lang=js&"
export * from "./DatatableCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports